import { inject, Service } from '@angular/core';
import { ToastController } from '@ionic/angular/lazy';

import { isNotNullOrEmpty, isNullOrEmpty } from '@/shared/lib/core/utils/data-validation.util';

import { NotificationType } from '../../constants/notification.enum';

@Service()
export class NotificationService {
  toastController = inject(ToastController);

  toast: HTMLIonToastElement | undefined;

  public async presentToast(toastMessage?: string, notificationType?: NotificationType, buttonClickOpenUrl?: string) {
    let toastClass: string;
    let toastIcon: string;
    switch (notificationType) {
      case NotificationType.Error:
        toastClass = 'notification-danger';
        toastIcon = 'alert-outline';
        break;
      case NotificationType.Warning:
        toastClass = 'notification-warning';
        toastIcon = 'alert-outline';
        break;
      case NotificationType.Success:
        toastClass = 'notification-success';
        toastIcon = 'checkmark-outline';
        break;
      default:
        toastClass = 'notification-success';
        toastIcon = 'checkmark-outline';
        break;
    }

    const toastButtonArray = isNotNullOrEmpty(buttonClickOpenUrl) ? [
        {
          text: 'Update',
          role: 'update',
          handler: () => {
            if (isNotNullOrEmpty(buttonClickOpenUrl)) {
              window.open(buttonClickOpenUrl, '_system');
            }
          },
        },
        {
          text: 'Close',
          role: 'cancel',
          handler: () => {
          },
        },
      ] :
      [
        {
          text: 'Close',
          role: 'cancel',
          handler: () => {
          },
        },
      ];

    if (isNullOrEmpty(this.toast)){
      this.toast = await this.toastController.create({
        message: toastMessage,
        cssClass: toastClass,
        positionAnchor: 'footer',
        duration: notificationType === NotificationType.ShortNotification ? 1000 : 1000000,
        buttons: toastButtonArray,
        icon: toastIcon
      });

      this.toast.present();
      this.toast.onDidDismiss().then(() => {
        this.toast = undefined;
      });
    }
  }
}
